import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom, filter } from 'rxjs/operators';
import { FacetService } from '../services/facet-service';
import * as facet from '../actions/facet';
import * as product from '../actions/product';
import * as status from '../../base/actions/status.actions';
import * as fromBase from '../../base/reducers';
import * as fromCatalog from '../reducers';
import * as fromUser from '../../auth/reducers/';
var FacetEffects = /** @class */ (function () {
    function FacetEffects(actions$, store, facetSvc) {
        var _this = this;
        this.actions$ = actions$;
        this.store = store;
        this.facetSvc = facetSvc;
        this.initFacetGroups$ = this.actions$.pipe(ofType(facet.INIT_GROUPS), withLatestFrom(this.store.pipe(select(fromCatalog.isFacetGroupsTtlExpired)), function (action, isFacetGroupsTtlExpired) { return ({ forceRefresh: action.forceRefresh, isFacetGroupsTtlExpired: isFacetGroupsTtlExpired }); }), switchMap(function (data) {
            var actionsArr = [];
            if (data.forceRefresh || data.isFacetGroupsTtlExpired) {
                actionsArr.push(new facet.GetGroups());
            }
            else {
                actionsArr.push(new facet.GetGroupsSkipped());
            }
            return of.apply(void 0, actionsArr);
        }));
        this.getFacetGroups$ = this.actions$
            .pipe(ofType(facet.GET_GROUPS), switchMap(function (action) {
            return _this.facetSvc.getFacetGroups()
                .pipe(map(function (groups) { return new facet.GetGroupsSuccess(groups); }), catchError(function (e) { return of(new facet.GetGroupsFailed(e)); }));
        }));
        this.initFacets$ = this.actions$.pipe(ofType(facet.INIT_FACETS), withLatestFrom(this.store.pipe(select(fromCatalog.isFacetsTtlExpired)), function (action, isFacetsTtlExpired) { return ({ forceRefresh: action.forceRefresh, isFacetsTtlExpired: isFacetsTtlExpired }); }), switchMap(function (data) {
            var actionsArr = [];
            if (data.forceRefresh || data.isFacetsTtlExpired) {
                actionsArr.push(new facet.GetFacets());
            }
            else {
                actionsArr.push(new facet.GetFacetsSkipped());
            }
            return of.apply(void 0, actionsArr);
        }));
        this.getFacets$ = this.actions$
            .pipe(ofType(facet.GET_FACETS), withLatestFrom(this.store.pipe(select(fromUser.getCustomerId)), function (action, customerId) { return ({ customerId: customerId }); }), switchMap(function (data) {
            return _this.facetSvc.getFacetBaseline(data.customerId)
                .pipe(map(function (baseline) { return new facet.GetFacetsSuccess(baseline); }), catchError(function (e) { return of(new facet.GetFacetsFailed(e)); }));
        }));
        this.initCompleted$ = this.actions$
            .pipe(ofType(status.APPLYSUCCESS), withLatestFrom(this.store.pipe(select(fromBase.loadProducts)), function (action, loadProducts) { return loadProducts; }), filter(function (loadProducts) { return loadProducts; }), switchMap(function () { return of(new facet.Filter(), new product.Filter(), new product.GetFavorites()); }));
        this.filterFacets$ = this.actions$
            .pipe(ofType(facet.FILTER), withLatestFrom(this.store.pipe(select(fromCatalog.getCombinedFilterState)), this.store.pipe(select(fromUser.getCustomerId)), this.store.pipe(select(fromBase.getPageParams)), this.store.pipe(select(fromCatalog.getOnlyInStock)), this.store.pipe(select(fromCatalog.getSearchTerm)), this.store.pipe(select(fromCatalog.getProductFilters)), function (action, state, customerId, params, onlyInStock, searchTerm, filterItems) { return ({ state: state, customerId: customerId, params: params, onlyInStock: onlyInStock, searchTerm: searchTerm, filterItems: filterItems }); }), switchMap(function (data) {
            return _this.facetSvc.getFacetCount(data.state.pageId, data.customerId, data.state.facets, data.params, data.onlyInStock, data.searchTerm, data.filterItems)
                .pipe(map(function (facets) { return new facet.FilterSuccess(facets); }), catchError(function (e) { return of(new facet.FilterFailed(e)); }));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "initFacetGroups$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "getFacetGroups$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "initFacets$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "getFacets$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "initCompleted$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], FacetEffects.prototype, "filterFacets$", void 0);
    return FacetEffects;
}());
export { FacetEffects };
